import { Link } from "react-router-dom";

import { legalEntityName, siteBrand } from "@consts";

import { SiteLogoMark } from "./SiteLogoMark";

type SiteLogoProps = {
  className?: string;
  markClassName?: string;
  showSubtitle?: boolean;
  onClick?: () => void;
};

export function SiteLogo({
  className = "",
  markClassName = "h-8 w-8 sm:h-9 sm:w-9",
  showSubtitle = true,
  onClick,
}: SiteLogoProps) {
  return (
    <Link
      to="/"
      title={siteBrand}
      aria-label={`${siteBrand} home`}
      onClick={onClick}
      className={`group flex shrink-0 items-center gap-2.5 sm:gap-3 ${className}`}
    >
      <SiteLogoMark
        className={`shrink-0 transition group-hover:scale-[1.03] ${markClassName}`}
      />
      <div className="min-w-0 text-left">
        <span className="block font-display text-xl font-semibold leading-none tracking-tight text-ink transition group-hover:text-accent sm:text-2xl">
          {siteBrand}
        </span>
        {showSubtitle ? (
          <span className="mt-1 hidden text-[10px] font-semibold uppercase tracking-[0.16em] text-faint sm:block">
            {legalEntityName}
          </span>
        ) : null}
      </div>
    </Link>
  );
}
